var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lx-modal-new',{staticClass:"root success-modal"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"img"}),_c('p',{staticClass:"msg"},[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }